module.exports = __webpack_public_path__ + "img/powder.7e8beffc.png";